<template>
    <b-form class="step-form" @submit.stop.prevent="onSubmit">
        <div v-if="!showPageLoader" class="row">
            <div class="col-lg-12">
                <h3>Step 1: Upload Documents</h3>
            </div>
            <div class="col-lg-8">
                <document-upload-guide-popup>
                </document-upload-guide-popup>
                <div class="row form-options">
                    <!--<div v-if="instance != 'United Arab Emirates'" class="col-lg-6">-->
                    <!--<identity-type :data-segment-id="dataSegmentId" :disabled="false"></identity-type>-->
                    <!--</div>-->
                    <template v-if="tempCountry=='UK' && getField('type') != 'company'">
                        <div 
                              class="col-lg-6">
                            <generic-drop-down :data-segment-id="dataSegmentId" 
                                :field="{
                                    isRequired: false,
                                    isLocked: true,
                                    title: 'Select ID Document Type',
                                    label: 'ID Document Type',
                                    placeholder: this.isCardType ? photoIdCardTypes.find((element) => element.value == this.isCardType).text :'Select ID Document Type',
                                    options: photoIdCardTypes,
                                    key: 'identityInfo.cardType',
                                    isDocType: this.isCardType
                                }"      
                                :disabled="false"></generic-drop-down>
                        </div>
                        <div class="col-lg-6">
                            <small class="mt-2"
                            ><em
                                class="dropzoneText"
                                style="float: right; cursor: pointer"
                                @click="openPopup('identity')"
                                >View Latest file</em
                            ></small
                            >
                            <cropper ref="cropper" 
                                v-if="showPhotoIdFrontDocumentUK"
                                :formData="formData2"
                                :isOcrField = "true"
                                :field="{
                                        isRequired: false,
                                        isLocked: true,
                                        key: 'documentInfo.identity.fileName',
                                        originalFileNameKey:
                                            'documentInfo.identity.originalFileName',
                                        label: 'ID Front Scan Copy',
                                        placeholder : placeHolderField,
                                        fileTypes : fileTypes
                                    }"
                            ></cropper>
                        </div>
                        <div class="col-lg-6" v-if="showPhotoIdBackDocumentUK">
                            <small class="mt-2"
                            ><em
                                class="dropzoneText"
                                style="float: right; cursor: pointer"
                                @click="openPopup('identityBack')"
                                >View Latest file</em
                            ></small
                        >
                            <id-back-cropper ref="cropper" 
                            :disabled="!allowPhotoIdBackDocumentUK"
                            :isOcrField = "true"
                            :notRequired = "true"
                            :field="{
                                isRequired: false,
                                isLocked: true,
                                key: 'documentInfo.identityBack.fileName',
                                originalFileNameKey:
                                    'documentInfo.identityBack.originalFileName',
                                label: 'ID Back Scan Copy',
                                placeholder : placeHolderField,
                                fileTypes : fileTypes
                            }"  
                            :formData="formData2"></id-back-cropper>
                        </div>
                        

                        <div class="col-12">
                            <hr/>
                        </div>
                        <div class="col-lg-6">
                            <generic-drop-down :data-segment-id="dataSegmentId"
                                :field="{
                                        isRequired: false,
                                        isLocked: true,
                                        title: 'Select Proof of Address Document Type',
                                        label: 'Proof of Address Document Type',
                                        placeholder: this.isAddrProf ? proofOfAddressCardTypesUK.find((element) => element.value == this.isAddrProf).text :'Select Proof of Address Document Type',
                                        options: proofOfAddressCardTypesUK,
                                        key: 'addressProofDocumentType',
                                        isDocType: this.isAddrProf
                                    }"
                            :disabled="false"></generic-drop-down>
                        </div>
                        <div class="col-lg-6" v-if="showAddressDoc">
                            <small class="mt-2"
                            ><em
                                class="dropzoneText"
                                style="float: right; cursor: pointer"
                                @click="openPopup('fieldAddressProof')"
                                >View Latest file</em
                            ></small>
                            <cropper ref="cropper"
                                :formData="formData2"
                                :verification="true"
                                :isOcrField = "false"
                                :field="{
                                        isRequired: false,
                                        isLocked: true,
                                        key: 'documentInfo.fieldAddressProof.fileName',
                                        originalFileNameKey:
                                            'documentInfo.fieldAddressProof.originalFileName',
                                        label: 'Proof of Address Document Scan Copy',
                                        placeholder : placeHolderField,
                                        fileTypes : fileTypes
                                    }"
                            ></cropper>
                        </div>

                        <div
                            v-if="
                                $store.state.registration.form.identityInfo.type
                            "
                                    class="col-lg-12"
                            >
                                <b-form-group
                                        label="Please upload all relevant documents"
                                        label-for="contact-email-input"
                                >
                                    <div>
                                        <vue-dropzone
                                                id="dropzone"
                                                ref="myVueDropzone"
                                                :options="dropzoneOptions"
                                                @vdropzone-complete="afterComplete"
                                                @vdropzone-removed-file="onFileRemove"
                                                @vdropzone-error="onError"
                                                @vdropzone-mounted="prePopulate"
                                        ></vue-dropzone>
                                    </div>
                                    <small class="mt-2"
                                    ><em class="dropzoneText"
                                    >Upload either DOC, DOCX, PDF, PNG, JPG (5MB
                                        MAX)</em
                                    ></small
                                    >
                                </b-form-group>
                            </div>


                    </template>
                    <template v-else-if="(tempCountry=='Qatar' || tempCountry=='UAE') && getField('type') != 'company'">
                        <div class="col-lg-6">
                            <small class="mt-2"
                            ><em
                                class="dropzoneText"
                                style="float: right; cursor: pointer"
                                @click="openPopup('identity')"
                                >View Latest file</em
                            ></small
                            >
                            <cropper ref="cropper"
                                     :formData="formData2"
                                     :isOcrField = "true"
                                     :field="{
                                        isRequired: false,
                                        isLocked: true,
                                        key: 'documentInfo.identity.fileName',
                                        originalFileNameKey:
                                            'documentInfo.identity.originalFileName',
                                        label: 'Passport photo page scan copy',
                                        placeholder : placeHolderField,
                                        fileTypes : fileTypes
                                    }"
                            ></cropper>
                        </div>
                        <div class="col-lg-12">
                            <hr/>
                        </div>
                        <div class="col-lg-6">
                            <generic-drop-down :data-segment-id="dataSegmentId"
                                               :field="{
                                    isRequired: false,
                                    isLocked: true,
                                    title: 'Select ID Document Type',
                                    label: 'ID Document Type',
                                    placeholder: this.isCardType ? photoIdCardTypes.find((element) => element.value == this.isCardType).text :'Select ID Document Type',
                                    options: photoIdCardTypes,
                                    key: 'identityInfo.cardType',
                                    isDocType: this.isCardType
                                }"
                                               :disabled="false"></generic-drop-down>
                        </div>
                        <div class="col-lg-6">
                            <small class="mt-2"
                            ><em
                                class="dropzoneText"
                                style="float: right; cursor: pointer"
                                @click="openPopup('fieldEmiratesID')"
                                >View Latest file</em
                            ></small
                            >
                            <cropper ref="cropper"
                                     v-if="showPhotoIdFrontDocumentUK"
                                     :formData="formData2"
                                     :isOcrField = "true"
                                     :field="{
                                        isRequired: false,
                                        isLocked: true,
                                        key: 'documentInfo.fieldEmiratesID.fileName',
                                        originalFileNameKey:
                                            'documentInfo.fieldEmiratesID.originalFileName',
                                        label: 'ID Front Scan Copy',
                                        placeholder : placeHolderField,
                                        fileTypes : fileTypes
                                    }"
                            ></cropper>
                        </div>
                        <div class="col-lg-6" v-if="showPhotoIdBackDocumentUK">
                            <small class="mt-2"
                            ><em
                                class="dropzoneText"
                                style="float: right; cursor: pointer"
                                @click="openPopup('fieldEmiratesIDBack')"
                                >View Latest file</em
                            ></small
                            >
                            <id-back-cropper ref="cropper"
                                             :isOcrField = "true"
                                             :field="{
                                isRequired: false,
                                isLocked: true,
                                key: 'documentInfo.fieldEmiratesIDBack.fileName',
                                originalFileNameKey:
                                    'documentInfo.fieldEmiratesIDBack.originalFileName',
                                label: 'ID Back Scan Copy',
                                placeholder : placeHolderField,
                                fileTypes : fileTypes
                            }"
                                             :formData="formData2"></id-back-cropper>
                        </div>
                        <div class="col-12">
                            <hr/>
                        </div>
                        <div :class="fieldVisaPage.show ? 'col-lg-6' : ''">
                            <div v-if="fieldVisaPage.show">
                                <small class="mt-2"
                                ><em
                                    class="dropzoneText"
                                    style="float: right; cursor: pointer"
                                    @click="openPopup('visaPage')"
                                    >View Latest file</em
                                ></small
                                >
                                <visa-page
                                        :profile-type="profileType"
                                ></visa-page>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <small class="mt-2"
                                ><em
                                    class="dropzoneText"
                                    style="float: right; cursor: pointer"
                                    @click="openPopup('fieldAddressProof')"
                                    >View Latest file</em
                                ></small
                                >
                            <div>
                                <address-proof></address-proof>
                            </div>
                        </div>
                        <div
                                v-if="
                                $store.state.registration.form.identityInfo.type
                            "
                                class="col-lg-12"
                        >
                            <b-form-group
                                    label="Please upload all relevant documents"
                                    label-for="contact-email-input"
                            >
                                <div>
                                    <vue-dropzone
                                            id="dropzone"
                                            ref="myVueDropzone"
                                            :options="dropzoneOptions"
                                            @vdropzone-complete="afterComplete"
                                            @vdropzone-removed-file="onFileRemove"
                                            @vdropzone-error="onError"
                                            @vdropzone-mounted="prePopulate"
                                    ></vue-dropzone>
                                </div>
                                <small class="mt-2"
                                ><em class="dropzoneText"
                                >Upload either DOC, DOCX, PDF, PNG, JPG (5MB
                                    MAX)</em
                                ></small
                                >
                            </b-form-group>
                        </div>
                    </template>
                    <template v-else>
                        <div v-if="instance == 'Pakistan' && !backScanCopyHidden && this.$store.getters.form.type!='company'"
                             :class="instance == 'Pakistan' ? 'col-lg-6' : ''">
                            <card-type :data-segment-id="dataSegmentId" :disabled="false" :notRequired="true"></card-type>
                        </div>
                        <div class="col-lg-6">
                            <small class="mt-2"
                            ><em
                                class="dropzoneText"
                                style="float: right; cursor: pointer"
                                @click="openPopup('identity')"
                                >View Latest file</em
                            ></small>
                            <cropper 
                                ref="cropper" 
                                :formData="formData2" 
                                :isOcrField = "getField('type') != 'company' ? true: false" 
                                :notRequired="true" 
                                :field="{
                                            isRequired: false,
                                            isLocked: true,
                                            key: 'documentInfo.identity.fileName',
                                            originalFileNameKey:
                                                'documentInfo.identity.originalFileName',
                                            label: getField('type') != 'company' ? 'ID Front Scan Copy': labelForCompanyId(),
                                            placeholder : placeHolderField,
                                            fileTypes : fileTypes
                                        }">
                            </cropper>
                        </div>

                        <div
                                v-if="instance == 'Pakistan' && !backScanCopyHidden && getField('type') != 'company'"
                                :class="instance == 'Pakistan' ? 'col-lg-6' : ''"
                        >
                            <id-back-cropper 
                                    ref="cropper" 
                                    :formData="formData2" 
                                    :isOcrField = "getField('type') != 'company'? true: false" 
                                    :notRequired="true"
                                    :field="{
                                        isRequired: false,
                                        isLocked: true,
                                        key: 'documentInfo.identityBack.fileName',
                                        originalFileNameKey:
                                            'documentInfo.identityBack.originalFileName',
                                        label: 'ID Back Scan Copy',
                                        placeholder : placeHolderField,
                                                fileTypes : fileTypes
                                    }"  >
                            </id-back-cropper>
                        </div>
                   <!--------------------- License Fields ------------------------>

                        <div
                          v-if="instance == 'Pakistan' && this.$store.getters.form.type!='company'"
                          class="col-lg-6">
                                <small class="mt-2"
                            ><em
                                class="dropzoneText"
                                style="float: right; cursor: pointer"
                                @click="openPopup('licenseFront')"
                                >View Latest file</em
                            ></small
                        >
                            <LicenseFrontCropper ref="cropper"></LicenseFrontCropper>
                        </div>

                        <div
                           v-if="instance == 'Pakistan' && this.$store.getters.form.type!='company'"
                           class="col-lg-6">
                                <small class="mt-2"
                            ><em
                                class="dropzoneText"
                                style="float: right; cursor: pointer"
                                @click="openPopup('licenseBack')"
                                >View Latest file</em
                            ></small
                        >
                            <LicenseBackCropper ref="cropper"></LicenseBackCropper>
                        </div>


                  <!-------------------- End of License Fields ------------------>

                        <!-- commenting consentForm feature temporarily for selfOnBoarding -->

                        <!-- <div
                        v-if="country == 'Pakistan' && ( formData2.degreeCheck || formData2.employmentCheck)"
                        class="col-lg-6">
                            <ConsentForm
                            ></ConsentForm>
                            <small class="mt-2"><em class="dropzoneText">Please download the attached form by
                            <a href='#' @click= 'consentFormDownload'>clicking here</a>, and upload the signed form</em>
                            </small>
                        </div> -->
                        <div
                                v-if="
                                instance == 'Pakistan' && getField('type') != 'company' &&
                                $store.state.registration.form.identityInfo.type
                            "
                                class="col-lg-12"
                        >
                            <b-form-group
                                    label="Please upload all relevant documents"
                                    label-for="contact-email-input"
                            >
                                <div>
                                    <vue-dropzone
                                            id="dropzone"
                                            ref="myVueDropzone"
                                            :options="dropzoneOptions"
                                            @vdropzone-complete="afterComplete"
                                            @vdropzone-removed-file="onFileRemove"
                                            @vdropzone-error="onError"
                                            @vdropzone-mounted="prePopulate"
                                    ></vue-dropzone>
                                </div>
                                <small class="mt-2"
                                ><em class="dropzoneText"
                                >Upload either DOC, DOCX, PDF, PNG, JPG (5MB
                                    MAX)</em
                                ></small
                                >
                            </b-form-group>
                        </div>
                        <!--if country is PAKISTAN-->

                        <!--if country is UAE-->
                        <div
                           v-if="instance != 'Pakistan' || this.$store.getters.form.type=='company'"
                           class="col-lg-12 row"
                        >
                            <div :class="fieldEmiratesID.show ? 'col-lg-6' : ''">
                                <div v-if="fieldEmiratesID.show">
                                    <small class="mt-2"
                                    ><em
                                        class="dropzoneText"
                                        style="float: right; cursor: pointer"
                                        @click="openPopup('fieldEmiratesID')"
                                        >View Latest file</em
                                    ></small
                                >
                                    <emirates-id
                                            :profile-type="profileType"
                                    ></emirates-id>
                                </div>
                            </div>
                            <div
                                    :class="fieldEmiratesIDBack.show ? 'col-lg-6' : ''"
                            >
                                <div v-if="fieldEmiratesIDBack.show">
                                    <small class="mt-2"
                                    ><em
                                        class="dropzoneText"
                                        style="float: right; cursor: pointer"
                                        @click="
                                            openPopup('fieldEmiratesIDBack')
                                        "
                                        >View Latest file</em
                                    ></small
                                >
                                    <emirates-id-back
                                            v-validate="{
                                            required: false,
                                        }"
                                            :profile-type="profileType"
                                    ></emirates-id-back>
                                </div>
                            </div>
                            <div :class="fieldVisaPage.show ? 'col-lg-6' : ''">
                                <div v-if="fieldVisaPage.show">
                                    <small class="mt-2"
                                    ><em
                                        class="dropzoneText"
                                        style="float: right; cursor: pointer"
                                        @click="openPopup('visaPage')"
                                        >View Latest file</em
                                    ></small
                                >
                                    <visa-page
                                            :profile-type="profileType"
                                    ></visa-page>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div>
                                    <small class="mt-2"
                                    ><em
                                        class="dropzoneText"
                                        style="float: right; cursor: pointer"
                                        @click="openPopup('fieldAddressProof')"
                                        >View Latest file</em
                                    ></small
                                >
                                    <address-proof></address-proof>
                                </div>
                            </div>
                            <!--if country is UAE-->
                            <div v-if="instance != 'Pakistan' || getField('type') == 'company' && $store.state.registration.form.identityInfo.type" class="col-lg-12">
                                <b-form-group
                                        label="Please upload all relevant documents"
                                        label-for="contact-email-input"
                                >
                                    <div>
                                        <vue-dropzone
                                                id="dropzone"
                                                ref="myVueDropzone"
                                                :options="dropzoneOptions"
                                                @vdropzone-complete="afterComplete"
                                                @vdropzone-removed-file="onFileRemove"
                                                @vdropzone-error="onError"
                                                @vdropzone-mounted="prePopulate"
                                        ></vue-dropzone>
                                    </div>
                                    <small class="mt-2"
                                    ><em class="dropzoneText"
                                    >Upload either DOC, DOCX, PDF, PNG, JPG
                                    (5MB MAX)</em
                                    ></small
                                    >
                                </b-form-group>
                            </div>

                        </div>
                        <!--if country is UAE-->

                    </template>


                </div>
                <div class="row mt-2">
                    <div class="col-lg-6">
                        <base-button
                            btn-type="submit"
                            btn-variant="primary"
                            btn-label="CONTINUE"
                            :class="loading ? 'disabled' : ''"
                            :disabled="loading"
                        ></base-button>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 mb-4 mb-md-0 form-options">
                <b-form-group
                    label="SAMPLE DOCUMENT"
                    label-for="sampleId"
                >
                <img 
                :style="{'display': this.customerType!='company' && this.formData2.documentValidation  ?'inline-block' : 'none' }"
                style="height: 30px !important;
                    position: absolute;
                    top: -47px;
                    left: 337px;"
                    @click="openGuideAfterFail"
                    :src="`${this.filesUrl}logo/circle-info.png`" 

                 >
                    <img
                            style="max-width: 270px"
                            v-authenticated-image="cardImageUrl"
                    />
                </b-form-group>
            </div>
            <id-card-preview-popup
                :item="customerDetails.documentInfo.identity"
            ></id-card-preview-popup>
            <id-card-back-preview-popup
                :item="customerDetails.documentInfo.identityBack"
            ></id-card-back-preview-popup>
            <license-front-popup
                :item="customerDetails.documentInfo.licenseFront">
            </license-front-popup>
            <license-back-popup
                :item="customerDetails.documentInfo.licenseBack">
            </license-back-popup>

            <visa-page-popup
                :item="customerDetails.documentInfo.visaPage"
            ></visa-page-popup>
            <emirates-id-popup
                :item="customerDetails.documentInfo.fieldEmiratesID"
            ></emirates-id-popup>
            <emirates-id-back-popup
                :item="customerDetails.documentInfo.fieldEmiratesIDBack"
            ></emirates-id-back-popup>
            <address-proof-popup
                :item="customerDetails.documentInfo.fieldAddressProof"
            ></address-proof-popup>
        </div>
        <base-table-spinner v-if="showPageLoader"></base-table-spinner>

    </b-form>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import request from '@/utils/request'
import _ from 'lodash'
// import axios from 'axios'

import IdentityType from '@/components/registration/IdentityType.vue'
import CardType from '@/components/registration/CardType.vue'
import GenericDropDown from '@/components/registration/GenericDropDown.vue'
//import IdentityDocument from '@/components/registration/IdentityDocument.vue'
import UtilityBill from '@/components/registration/UtilityBill.vue'
import VisaPage from '@/components/registration/VisaPage.vue'
import EmiratesId from '@/components/registration/EmiratesId.vue'
import EmiratesIdBack from '@/components/registration/EmiratesIdBack.vue'
import AddressProof from '@/components/registration/AddressProof.vue'
import Cropper from '@/components/registration/Cropper.vue'
import IdBackCropper from '@/components/registration/IdBackCropper.vue'
import AdditionalDocument from '@/components/registration/AdditionalDocument.vue'
import proofOfEmployment from '@/components/registration/ProofOfEmployment.vue'
import EducationalDocument from '@/components/registration/EducationalDocument.vue'
// import ConsentForm from '@/components/registration/ConsentForm.vue'
import LicenseFrontCropper from '@/components/registration/LicenseFrontCropper.vue'
import LicenseBackCropper from '@/components/registration/LicenseBackCropper.vue'

//PopUp components
import idCardPreviewPopup from '@/components/popups/IDCardPreviewPopup.vue'
import idCardBackPreviewPopup from '@/components/popups/IDCardBackPreviewPopup.vue'
import visaPagePopup from '@/components/popups/VisaPagePopup.vue'
import emiratesIdPopup from '@/components/popups/EmiratesIdPopup.vue'
import addressProofPopup from '@/components/popups/AddressProofPopup.vue'
import emiratesIdBackPopup from '@/components/popups/EmiratesIdBackPopup.vue'
import LicenseFrontPopup from '../../components/popups/LicenseFrontPopup.vue'
import LicenseBackPopup from '../../components/popups/LicenseBackPopup.vue'
import DocumentUploadGuidePopup from '../../components/popups/DocumentUploadGuidePopup.vue'


import resource from '@/api/resource'

const dataSegmentApi = new resource('users/data-segment')
const viewBrandingApi = new resource('configurations/branding')
const modulesApi = new resource('configurations/modules')
import vue2Dropzone from 'vue2-dropzone'

import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { ocr,setDocumetSummary } from '../../utils/functions';
import BaseTableSpinner from "../../components/BaseTableSpinner";

export default {
    /*
      |--------------------------------------------------------------------------
      | Component > components
      |--------------------------------------------------------------------------
      */
    components: {
        BaseTableSpinner,
        DocumentUploadGuidePopup,
        IdentityType,
        CardType,
        GenericDropDown,
        Cropper,
        // ConsentForm,
        //IdentityDocument,
        UtilityBill,
        VisaPage,
        EmiratesId,
        AddressProof,
        EmiratesIdBack,
        IdBackCropper,
        LicenseFrontCropper,
        LicenseBackCropper,
        AdditionalDocument,
        proofOfEmployment,
        EducationalDocument,
        vueDropzone: vue2Dropzone,
        //PopUps
        idCardPreviewPopup,
        idCardBackPreviewPopup,
        LicenseFrontPopup,
        LicenseBackPopup,
        visaPagePopup,
        emiratesIdPopup,
        addressProofPopup,
        emiratesIdBackPopup
    }, // End of Component > components

    /*
      |--------------------------------------------------------------------------
      | Component > props
      |--------------------------------------------------------------------------
      */
    props: {}, // End of Component > props

    /*
      |--------------------------------------------------------------------------
      | Component > data
      |--------------------------------------------------------------------------
      */
    data() {
        return {
            showPageLoader: true,
            brandingApiData:'',
            isOnMountedIdFront : false, // using this to check if file is fetch from api or not if yes dont run OCR
            isOnMountedIdBack : false,
            isOnMountedFieldEmiratesID:false,
            isOnMountedFieldEmiratesIDBack:false,  // using this to check if file is fetch from api or not if yes dont run OCR
            customerDetails: [],
            dataFetch: false,
            soundeffect: new Audio(),
            country: process.env.VUE_APP_COUNTRY,
            tempCountry: process.env.VUE_APP_COUNTRY_TEMP,
            filesUrl:process.env.VUE_APP_FILE_SERVICE_URL,
            liveness: null,
            counter: null,
            subscription: null,
            redirection: true,
            tier: null,
            nameScreening: null,
            deepLinkRegisteredCount: 0,
            query: {
                startAt: 1,
                keyword: '',
                perPage: 10,
                status: null,
                sortBy: 'idenfoId',
                sortOrder: 'desc',
            },
            riskFactor: null,
            path: 'users/temp-applications',

            resourceApi: null,
            // cardImageUrl : '',
            associateData: [],
            formData2: {
                dataSegmentId: null,
                riskFactor: null,
                liveness: null,
                nameScreening: null,
                documentUpload: null,
                documentValidation: null,
                companyType: null,
            },
            fieldVisaPage: {
                show: true,
            },
            fieldEmiratesID: {
                show: true,
            },
            fieldAddressProof: {
                show: true,
            },
            fieldEmiratesIDBack: {
                show: true,
            },
            profileType: '',
            backScanCopyHidden: false,
            dropzoneOptions: {
                url: process.env.VUE_APP_FILE_SERVICE_URL,
                autoProcessQueue: true,
                // acceptedFiles: "image/jpeg,image/png,image/gif",
                acceptedFiles:
                    'application/pdf,.doc,.docx , image/png, .jpg,.jpeg',
                uploadMultiple: false,
                maxFiles: 10,
                maxFilesize: 5,
                addRemoveLinks: true,
                dictDefaultMessage: 'Drop file here or Select file',
                init: function () {
                    this.on('sending', function (file, xhr, formData) {
                        formData.append('type', 'otherDocuments')
                    })
                },
            },
            photoIdCardTypeLists: [
                {
                        text: 'No Document Type Selected',
                        value: '',
                },
                {
                    text: 'Passport',
                    value: 'passport',
                },
                {
                    text: 'Passport MRZ',
                    value: 'passportMRZ',
                },
                            {
                                text: 'Driving Licence',
                                value: 'license',
                            },
                            {
                                text: 'Biometric Residence Permit',
                                value: 'brp',
                            },
                            {
                                text: 'Qatar Residence Permit',
                                value: 'qrp',
                            },
                            {
                                text: 'UAE Old Resident Card',
                                value: 'uaeOldResidentCard',
                            },
                            {
                                text: 'UAE Smart Resident Card',
                                value: 'uaeSmartResidentCard',
                            },
                        ],
                proofOfAddressCardTypesUK: [
                            {
                                text: 'Driving Licence',
                                value:'Driving Licence',
                            },
                            {
                                text: 'Credit Card statement',
                                value:'Credit Card statement',
                            },
                            {
                                text: 'Bank statement',
                                value:'Bank statement',
                            },
                            {
                                text: 'Tax Bill',
                                value:'Tax Bill',
                            },
                            {
                                text: 'Utility Bill',
                                value:'Utility Bill',
                            },
                            {
                                text: 'Mortgage Statement',
                                value:'Mortgage Statement',
                            },
                            {
                                text: 'Rental Agreement',
                                value:'Rental Agreement',
                            },
                        ],
            placeHolderField :'Select scan copy (JPG, PNG, PDF or JPEG file)',
            fileTypes:"image/*,application/pdf"
        }
    }, // End of Component > data

    created() {
        this.resourceApi = new resource(this.path)

        // if (this.field.key == 'pepDeclaration.other') {
        // console.log(this.$store.state.registration.form.pepInfo)
        if (process.env.VUE_APP_COUNTRY == 'Pakistan') {
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.identityInfo.type
                },
                (newValue, oldValue) => {
                    // console.log("new Value",newValue)
                    if (newValue == 'passport' || newValue == 'passportMRZ') {
                        this.backScanCopyHidden = true
                    } else {
                        this.backScanCopyHidden = false
                    }
                }
            )
        }
        // }
    },

    /*
      |--------------------------------------------------------------------------
      | Component > computed
      |--------------------------------------------------------------------------
      */
    computed: {
        ...mapState({
            userOcr: (state) => state.registration.useOcr,
        }),

        ...mapGetters(['dataSegmentId', 'loading', 'form', 'user','getRegState','getField','cardTypeOverride']),

        cardImageUrl(){

                if(this.customerType != 'company'){
                    return 'logo/'+this.brandingApiData.idCard.fileName
                }else{
                    return 'logo/'+this.brandingApiData.companyLicense.fileName

                }
        },
        addressProofReq() {
            if (process.env.VUE_APP_COUNTRY_TEMP == 'UK') {
                return true
            }
            return false
        },
        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
        instance() {
            if (process.env.VUE_APP_COUNTRY == 'Pakistan') {
                this.$store.commit('updateField', {
                    key: 'identityInfo.type',
                    value: 'id',
                })
                return 'Pakistan'
            } else {
                this.$store.commit('updateField', {
                    key: 'identityInfo.type',
                    value: 'passport',
                })
                return process.env.VUE_APP_COUNTRY
            }
        },
        isCardType(){
               return this.$store.getters.getField("identityInfo.cardType")
            },
        isAddrProf(){
              return this.getField('documentInfo.fieldAddressProof.addressProofDocumentType')
            },
        showPhotoIdFrontDocumentUK() {
                let cardType = this.$store.getters.getField("identityInfo.cardType");
                return !!cardType;
            },
         showPhotoIdBackDocumentUK() {
                let passportTypes = ['passport', 'passportMRZ'] 
                let cardType = this.$store.getters.getField("identityInfo.cardType");
                return !!cardType && !passportTypes.includes(cardType);
            },
        allowPhotoIdBackDocumentUK() {
                let cardType = this.$store.getters.getField("identityInfo.cardType");
                return !!cardType && cardType != 'passport' && !!this.$store.getters.getField("documentInfo.identity.fileName");
            },
            photoIdCardTypes(){
                let UKLists =['passport','license','brp']
                // let UAELists = ['passportMRZ','uaeOldResidentCard','uaeSmartResidentCard']
                // let QatarLists = ['passportMRZ','qrp']

                let UAELists = ['','uaeOldResidentCard','uaeSmartResidentCard']
                let QatarLists = ['','qrp']
                
                if( this.tempCountry =='UK'){
                    let array = this.photoIdCardTypeLists.filter((el)=> UKLists.includes(el.value)==true)
                    return array
                    // array.map(item => {
                    //     if (item.value.toLowerCase() === 'passportmrz') {
                    //         return { ...item, text: 'Overseas Passport' };
                    //     }
                    //     return item;
                    // });
                }
                else if(this.tempCountry == 'Qatar'){
                    return  this.photoIdCardTypeLists.filter((el)=> QatarLists.includes(el.value)==true)
                }
                else{
                    return  this.photoIdCardTypeLists.filter((el)=> UAELists.includes(el.value)==true)
                }
            },
            customerType(){
                return this.form.type
            }
    }, // End of Component > computed

    /*
      |--------------------------------------------------------------------------
      | Component > watch
      |--------------------------------------------------------------------------
      */

    watch: {
        /**
         * Handle when the file is uploaded successfully
         *
         * @return {void}
         */
        dataSegmentId(value) {
            if (value) {
                this.getModuleData()
            }
        },
        'form.identityInfo.cardType'(value, oldValue){
                 console.log("cardType old value from edit profile",oldValue)
                    if( oldValue && this.isOcrCountry() && this.getField('type') != 'company'){
                        this.ocrFieldReset(oldValue)
                    }
                    if(this.tempCountry == 'UK' && value) {
                        if(value == 'license') {
                            this.proofOfAddressCardTypesUK = this.proofOfAddressCardTypesUK.filter(el => el.text != 'Driving Licence');
                            if( this.getRegState('addressProofDocumentType') == 'Driving Licence'){
                            this.$store.commit('setValue', {
                                key: 'addressProofDocumentType',
                                value: null,
                            })
                            }
                        }
                        else if(!this.proofOfAddressCardTypesUK.find(el=>el.text =='Driving Licence')){
                            this.proofOfAddressCardTypesUK = [ {
                                    text: 'Driving Licence',
                                    value:'Driving Licence',
                                }, ...this.proofOfAddressCardTypesUK]
                        }
                }
            },
            async 'form.documentInfo.identity.fileName'(value,oldValue) {
                try {
                    // check if the value is not empty
                    if(value!=null &&  typeof(value)=='string')
                    {   
                        // let ocrResponse = await this.ocrValidation(value,'FRONT')
                        if (   this.$store.getters.form.type!='company' && this.isOcrCountry()
                            && this.formData2.documentValidation && !value.split(".").includes("pdf")
                            && !this.isOnMountedIdFront
                           ) {
                            this.$store.commit('setValue', {
                                            key:'cardTypeOverride',
                                            value: null
                                        });
                            await ocr(value, 'FRONT',null,false,this.twoIdentityDocs())
                            .then((result)=>{
                                if(result && result.result && result.card_type){
                                    this.$store.commit('setValue', {
                                        key:'cardTypeOverride',
                                        value: result.card_type
                                    });
                                }

                                // console.log("ocr front result:", result)
                                result.fieldKey = 'documentInfo.identity.fileName'
                                this.$store.commit('setValue', {
                                                key: 'ocrStatusFront',
                                                value: result,
                                            })
                                setDocumetSummary(result,'identity')
                            })
                        }else if (
                                       this.$store.getters.form.type!='company' && this.isOcrCountry()
                                    && this.formData2.documentValidation && !value.split(".").includes("pdf")
                                )
                        {
                            this.isOnMountedIdFront = false
                        }
                    }else if(oldValue!=null &&  typeof(oldValue)=='string' && this.$store.getters.form.type!='company'&& this.isOcrCountry() &&
                            this.formData2.documentValidation && !oldValue.split(".").includes("pdf")){
                                setDocumetSummary(false,'identity',true)
                    }

                } catch (error) {
                    console.log('OCR error 2',error)
                }
                this.$store.commit('setLoading', false)
            },
            async 'form.documentInfo.identityBack.fileName'(value,oldValue) {
                try {
                    // check if the value is not empty
                    if(value!=null &&  typeof(value)=='string') {
                        // let ocrResponse = await this.ocrValidation(value,'BACK')
                        if (    this.$store.getters.form.type!='company' && this.isOcrCountry
                             && this.formData2.documentValidation && !value.split(".").includes("pdf")
                             && !this.isOnMountedIdBack
                            ) {
                            await ocr(value, 'BACK', this.cardTypeOverride ? this.cardTypeOverride.replace('FRONT', 'BACK') : null)
                            .then((result)=>{
                                result.fieldKey = 'documentInfo.identityBack.fileName'
                                this.$store.commit('setValue', {
                                                key: 'ocrStatusBack',
                                                value: result,
                                            })
                                setDocumetSummary(result,'identityBack')
                            })
                        }else if( 
                                        this.$store.getters.form.type!='company' && this.isOcrCountry
                                    && this.formData2.documentValidation && !value.split(".").includes("pdf")
                                ){
                                   this.isOnMountedIdBack = false
                        }
                    }else if(oldValue!=null &&  typeof(oldValue)=='string' && this.$store.getters.form.type!='company'&& this.isOcrCountry() &&
                            this.formData2.documentValidation && !oldValue.split(".").includes("pdf")){
                                       setDocumetSummary(false,'identityBack',true)
                                    }

                } catch (error) {
                    console.log('OCR error 3',error)
                }
                this.$store.commit('setLoading', false)
            },
            async 'form.documentInfo.fieldEmiratesID.fileName'(value,oldValue) {
                try {
                    // check if the value is not empty
                    if(value!=null &&  typeof(value)=='string')
                    {
                        // let ocrResponse = await this.ocrValidation(value,'FRONT')
                        if (   this.$store.getters.form.type!='company' && this.isOcrCountry()
                            && this.formData2.documentValidation && !value.split(".").includes("pdf")
                            && !this.isOnMountedFieldEmiratesID
                        ) {
                            this.$store.commit('setValue', {
                                key:'cardTypeOverride',
                                value: null
                            });
                            await ocr(value, 'FRONT')
                                .then((result)=>{
                                    if(result && result.result && result.card_type){
                                        this.$store.commit('setValue', {
                                            key:'cardTypeOverride',
                                            value: result.card_type
                                        });
                                    }

                                    // console.log("ocr front result:", result)
                                    result.fieldKey = 'documentInfo.fieldEmiratesID.fileName'
                                    this.$store.commit('setValue', {
                                        key: 'ocrStatusFront',
                                        value: result,
                                    })
                                    setDocumetSummary(result,'fieldEmiratesID')
                                })
                        }else if (
                                       this.$store.getters.form.type!='company' && this.isOcrCountry()
                                    && this.formData2.documentValidation && !value.split(".").includes("pdf")
                                )
                        {
                            this.isOnMountedFieldEmiratesID = false
                        }
                            
                    }else if(oldValue!=null &&  typeof(oldValue)=='string' && this.$store.getters.form.type!='company'&& this.isOcrCountry() &&
                            this.formData2.documentValidation && !oldValue.split(".").includes("pdf")){
                                       setDocumetSummary(false,'fieldEmiratesID',true)
                    }

                } catch (error) {
                    console.log('OCR error 2',error)
                }
                this.$store.commit('setLoading', false)
            }, // End of user() method
            async 'form.documentInfo.fieldEmiratesIDBack.fileName'(value,oldValue) {
                try {
                    // check if the value is not empty
                    if(value!=null &&  typeof(value)=='string') {
                        // let ocrResponse = await this.ocrValidation(value,'BACK')
                        if (    this.$store.getters.form.type!='company' && this.isOcrCountry()
                            && this.formData2.documentValidation && !value.split(".").includes("pdf")
                            && !this.isOnMountedFieldEmiratesIDBack
                        ) {
                            await ocr(value, 'BACK', this.cardTypeOverride ? this.cardTypeOverride.replace('FRONT', 'BACK') : null)
                                .then((result)=>{
                                    this.$store.commit('setValue', {
                                        key: 'ocrStatusBack',
                                        value: result,
                                    })
                                    setDocumetSummary(result,'fieldEmiratesIDBack')
                                })
                        }else if( 
                                        this.$store.getters.form.type!='company' && this.isOcrCountry
                                    && this.formData2.documentValidation && !value.split(".").includes("pdf")
                                ){
                                   this.isOnMountedFieldEmiratesIDBack = false
                        }
                    }else if(oldValue!=null &&  typeof(oldValue)=='string' && this.$store.getters.form.type!='company'&& this.isOcrCountry() &&
                            this.formData2.documentValidation && !oldValue.split(".").includes("pdf")){
                                       setDocumetSummary(false,'fieldEmiratesIDBack',true)
                    }

                } catch (error) {
                    console.log('OCR error 3',error)
                }
                this.$store.commit('setLoading', false)
            },
      
    }, // End of Component > methods

    /*
      |--------------------------------------------------------------------------
      | Component > mounted
      |--------------------------------------------------------------------------
      */
    async mounted() {
        if(this.tempCountry == 'UK' && this.isCardType) {
                    if(this.isCardType == 'license') {
                        this.proofOfAddressCardTypesUK = this.proofOfAddressCardTypesUK.filter(el => el.text != 'Driving Licence');
                    }
                }
        this.getBrandingData()
        if (!this.dataSegmentId) {
            this.$router.push({ name: 'login-page' })
        }
        await this.getModuleData()
        if(!this.formData2.liveness)
        {
            // this.placeHolderField = 'Select scan copy (JPG, PNG or TIFF file)'
            // this.fileTypes = "image/*"
        }
        // console.log('formdata2', this.formData2)
        // console.log('params', this.$route.params.id)
        if (this.formData2) {
            // if (
            //     this.formData2.documentUpload == false &&
            //     this.formData2.nameScreening
            // ) {
            //     this.$router.push({ name: 'edit-profile-setup-profile' })
            // } else if (
            //     !this.formData2.documentUpload &&
            //     !this.formData2.nameScreening
            // ) {
            //     this.$router.push({ name: 'edit-profile-account-info' })
            // } else if (this.formData2.documentUpload)
            {
                try {
                    let { data } = await request({
                        url: `customers/document-status/${this.$route.params.id}`,
                    })
                    let docInfo = await request({
                        url: `customers/documentInfo-for-edit-profile/${this.$route.params.id}`,
                    })
                    let isData = docInfo && docInfo.data && docInfo.data.data 
                    let docInfoApi = docInfo.data.data
                    let isDocInfo = isData && docInfoApi.documentInfo
                    let documentInfo = docInfoApi.documentInfo
                    let isSourceOfFundsDocInfo = docInfoApi.sourceOfFunds && docInfoApi.sourceOfFunds.evidenceDocument
                    let sourceOfFundsDocInfo = docInfoApi.sourceOfFunds.evidenceDocument
                    let isSourceOfWealthDocInfo = docInfoApi.sourceOfWealth && docInfoApi.sourceOfWealth.evidenceDocument
                    let sourceOfWealthDocInfo = docInfoApi.sourceOfWealth.evidenceDocument
                    
                    if(data && data.data){
                    this.customerDetails = data.data
                    if(!this.getField('type')){
                            if(isData){
                                if(isDocInfo){
                                    this.isOnMountedIdFront = documentInfo.identity.fileName ? true : false 
                                    this.isOnMountedIdBack = documentInfo.identityBack.fileName ? true : false
                                    this.isOnMountedFieldEmiratesID = documentInfo.fieldEmiratesID.fileName ? true : false 
                                    this.isOnMountedFieldEmiratesIDBack = documentInfo.fieldEmiratesIDBack.fileName ? true : false
                                    for(let doc in documentInfo){
                                        if(documentInfo[doc] && typeof documentInfo[doc] == 'object' && !documentInfo[doc].fileName){
                                            documentInfo[doc].fileName = null
                                            documentInfo[doc].originalFileName =  null 
                                        }
                                    }
                                    this.$store.commit('updateField', {
                                    key: 'documentInfo',
                                    value: documentInfo,
                                    })
                                }
                                if(isSourceOfFundsDocInfo){
                                        this.$store.commit('updateField', {
                                    key: 'sourceOfFunds.evidenceDocument',
                                    value: sourceOfFundsDocInfo,
                                    })
                                }
                                if(isSourceOfWealthDocInfo){
                                        this.$store.commit('updateField', {
                                            key: 'sourceOfWealth.evidenceDocument',
                                            value: sourceOfWealthDocInfo,
                                       })
                                }

                            }
                            this.$store.commit('updateField', {
                            key: 'idenfoId',
                            value: data.data.idenfoId,
                            })
                            this.$store.commit('updateField', {
                                key: 'type',
                                value: data.data.type ? data.data.type : 'individual' ,
                            })
                            if(data.data.identityInfo){
                                    this.$store.commit('updateField', {
                                        key: 'identityInfo.cardType',
                                        value: data.data.identityInfo.cardType ? data.data.identityInfo.cardType : null ,
                                    })    

                            }
                           
                            this.$store.commit('updateField', {
                            key: '_id',
                            value: data.data._id,
                            })

                        if( data.data.documentInfo.identity.fileName){
                            this.$store.commit('updateField', {
                            key: 'IdPreview',
                            value: data.data.documentInfo.identity.fileName,
                            })
                        }
                  }
                }
                } catch (error) {
                    console.log(error)
                }
            }
        }

    }, // End of Component > watch

    /*
      |--------------------------------------------------------------------------
      | Component > methods
      |--------------------------------------------------------------------------
      */
    methods: {
        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */
         ...mapMutations(['setValue']), 
                openGuideAfterFail(){
                       this.setValue({
                                key: 'isShowGuide',
                                value: true,
                            })
             },
           labelForCompanyId(){
               if(['UK'].includes(this.tempCountry)){
                 return "Certificate of incorporation"
               }
               else{
                 return "Trade License / Registration Certificate"
               }
            },
         twoIdentityDocs(){
                let countries = ['UAE','Qatar']
                if(countries.includes(this.tempCountry)){
                  return 'passportMRZ'
                }
                return false
             },
        showAddressDoc()
        {
            let cardType = this.$store.getters.getField("documentInfo.fieldAddressProof.addressProofDocumentType");
            console.log('------card typee=------',cardType)
            return !!cardType;
        },
         isGenericDropdownCountry() {
            if (
                (this.country == 'United Arab Emirates' ||
                this.tempCountry == 'UK' ||
                this.tempCountry == 'Qatar') && this.customerType != 'company'
            ) {
                return true
            }
            return false
        }, 
         isOcrCountry(){
          if( this.country == 'United Arab Emirates' || this.country == 'Pakistan' ||  (this.tempCountry == 'UK' || this.tempCountry == 'Qatar')){
            return true
          }
          return false
        },
         async ocrFieldReset(oldCardType) {
                let TypesForIdentityInfo = ['license','brp','URDU','SMART','nicopNew','nicopOld','qrp','uaeOldResidentCard', 'uaeSmartResidentCard']
                let TypesForPassport = ['passport','passportMRZ']
                let TypesForNationality = ['SMART','nicopNew','nicopOld','passport','passportMRZ', 'brp','qrp','uaeOldResidentCard', 'uaeSmartResidentCard']
                let TypesForGender = ['SMART','nicopNew','nicopOld','passport','passportMRZ', 'brp']
                let TypesForGeneric = ['license','SMART','URDU','nicopNew','nicopOld','passport','passportMRZ']
                let TypeForFatherName = ['SMART','nicopNew','nicopOld']
                let cardType = oldCardType

                if(TypesForGeneric.includes(cardType)){
                        this.$store.commit('updateField', {
                            key: 'basicInfo.firstName',
                            value: null,
                        })
                        this.$store.commit('updateField', {
                            key: 'basicInfo.dateOfBirth',
                            value:null,
                        })
                        this.$store.commit('updateField', {
                            key: 'documentInfo.ocrPicture.fileName',
                            value: null,
                        })
               } 
                if(TypesForGender.includes(cardType)){
                    this.$store.commit('updateField', {
                        key: 'basicInfo.gender',
                        value: null,
                    })
                    this.$store.commit('updateField', {
                        key: 'basicInfo.genderId',
                        value: null,
                    })
                }
                if(TypesForNationality.includes(cardType)){
                    this.$store.commit('updateField', {
                        key: 'basicInfo.nationalityId',
                        value: null,
                    })
                    this.$store.commit('updateField', {
                        key: 'basicInfo.nationality',
                        value: null,
                    })
                }
                if( TypesForIdentityInfo.includes(cardType)){
                    this.$store.commit('updateField', {
                        key: 'identityInfo.number',
                        value: null,
                    })
                    this.$store.commit('updateField', {
                        key: 'identityInfo.expiryDate',
                        value:null,
                    })
                    this.$store.commit('updateField', {
                        key: 'identityInfo.documentSummary',
                        value: {}
                    })
                    this.$store.commit('updateField', {
                        key: 'identityInfo.documentSummaryBack',
                        value: {}
                    })
                
                }

                if( TypesForPassport.includes(cardType))
            {
                    this.$store.commit('updateField', {
                        key: 'identityInfo.passport.number',
                        value: null,
                    })
                    this.$store.commit('updateField', {
                        key: 'identityInfo.passport.expiryDate',
                        value: null,
                    })
                    this.$store.commit('updateField', {
                        key: 'identityInfo.passport.documentSummary',
                        value: {}
                    })
                    // this.$store.commit('updateField', {
                    //     key: 'identityInfo.isLifetimeExpiry',
                    //     value: null,
                    // })
                }
            
                if( this.country == 'Pakistan' && TypeForFatherName.includes(cardType)){
                    this.$store.commit('updateField', {
                        key: 'basicInfo.fatherName',
                        value: null,
                    })
                }
            
            },
  
        async prePopulate(){
             if(!this.$store.state.registration.form.documentInfo.otherDocuments){
              let docs = this.customerDetails.documentInfo.otherDocuments
            // console.log("logs from prepopulate",docs)
              let size
              for(var i=0; i<docs.length;i++){
    
                   let url = `${process.env.VUE_APP_FILE_SERVICE_URL}customer-documents/${docs[i].fileName}`
                 await fetch(url, {
                   method: 'HEAD'
                    })
                  .then(response => response.headers.get('Content-Length'))
                  .then(s => size=s);
                  var file = { size:size, name: docs[i].originalFileName,...docs[i] };
                   await this.$refs.myVueDropzone.manuallyAddFile(file, url);
                }
                this.$store.commit('updateField', {
                key: 'documentInfo.otherDocuments',
                value: docs,
            })
        }else{
            let docs = this.$store.state.registration.form.documentInfo.otherDocuments
              console.log("logs from prepopulate",docs)
              let size
              for(var i=0; i<docs.length;i++){
    
                   let url = `${process.env.VUE_APP_FILE_SERVICE_URL}customer-documents/${docs[i].fileName}`
                 await fetch(url, {
                   method: 'HEAD'
                    })
                  .then(response => response.headers.get('Content-Length'))
                  .then(s => size=s);
                  var file = { size:size, name: docs[i].originalFileName,...docs[i] };
                   await this.$refs.myVueDropzone.manuallyAddFile(file, url);
                }
                this.$store.commit('updateField', {
                key: 'documentInfo.otherDocuments',
                value: docs,
            })  
        }
// })

           
        },
        openPopup(popup) {
            console.log('popup', popup)
            switch (popup) {
                case 'picture':
                    this.$bvModal.show('picture-preview-popup')
                    break
                case 'video':
                    this.$bvModal.show('document-preview-popup')
                    break
                case 'identity':
                    if (this.customerDetails.documentInfo.identity.fileName) {
                        this.$bvModal.show('id-card-preview-popup')
                    } else {
                        this.$store.commit('setError', 'No file uploaded')
                    }
                    break
                case 'identityBack':
                    if (this.customerDetails.documentInfo.identityBack.fileName) {
                        this.$bvModal.show('id-card-back-preview-popup')
                    } else {
                        this.$store.commit('setError', 'No file uploaded')
                    }
                    break
                case 'licenseFront':
                    if (this.customerDetails.documentInfo.licenseFront.fileName) {
                        this.$bvModal.show('license-front-preview-popup')
                    } else {
                        this.$store.commit('setError', 'No file uploaded')
                    }
                    break
                case 'licenseBack':
                    if (this.customerDetails.documentInfo.licenseBack.fileName) {
                        this.$bvModal.show('license-back-preview-popup')
                    } else {
                        this.$store.commit('setError', 'No file uploaded')
                    }
                    break
                case 'utility':
                    this.$bvModal.show('bill-preview-popup')
                    break
                case 'wealthEvidenceDocument':
                    this.$bvModal.show('sourceofwealth-document')
                    break
                case 'fundsEvidenceDocument':
                    this.$bvModal.show('sourceoffunds-document')
                    break
                case 'visaPage':
                    if (this.customerDetails.documentInfo.visaPage.fileName) {
                        this.$bvModal.show('visa-page-document')
                    } else {
                        this.$store.commit('setError', 'No file uploaded')
                    }
                    break
                case 'fieldEmiratesID':
                    if (
                        this.customerDetails.documentInfo.fieldEmiratesID
                            .fileName
                    ) {
                        this.$bvModal.show('emirates-id-popup')
                    } else {
                        this.$store.commit('setError', 'No file uploaded')
                    }
                    break
                case 'fieldEmiratesIDBack':
                    if (
                        this.customerDetails.documentInfo.fieldEmiratesIDBack
                            .fileName
                    ) {
                        this.$bvModal.show('emirates-id-back-popup')
                    } else {
                        this.$store.commit('setError', 'No file uploaded')
                    }
                    break
                case 'fieldAddressProof':
                    if (
                        this.customerDetails.documentInfo.fieldAddressProof
                            .fileName
                    ) {
                        this.$bvModal.show('address-proof-popup')
                    } else {
                        this.$store.commit('setError', 'No file uploaded')
                    }
                    break
                case 'uploadDocuments':
                    this.$bvModal.show('upload-verification-documents-popup')
                    break
            }
        },
        onError(file, message, xhr) {
            // console.log('on upload error',file,message,xhr)
            this.$refs.myVueDropzone.removeFile(file)
            this.$store.commit('setError', message)
        },
        onFileRemove(file) {
            if (this.$route.name == 'edit-profile-upload-document') {
                let arr = []
                if (
                    this.$store.state.registration.form.documentInfo
                        .otherDocuments !== undefined
                ) {
                    if (
                        this.$store.state.registration.form.documentInfo
                            .otherDocuments.length > 1
                    ) {
                        this.$store.state.registration.form.documentInfo.otherDocuments.forEach(
                            (value, index) => {
                                if (value.uploadID == file.uploadID ) {
                            
                                }
                                else {
                                    let fileObj = {
                                        fileName: value.fileName,
                                        originalFileName:
                                            value.originalFileName,
                                        uploadID: value.uploadID,
                                    }
                                    arr.push(fileObj)
                                    this.updateOriginalFileName(arr)
                                }
                            }
                        )
                    } else {
                        this.updateOriginalFileName(arr)
                    }
                }
            }
        },
        afterComplete(file) {
            let response = JSON.parse(file.xhr.response)
            console.log(response.data.fileName)
            let fileObj = {
                fileName: response.data.fileName,
                originalFileName: file.name,
                uploadID: file.upload.uuid,
            }
            let arr = []
            if (
                this.$store.state.registration.form.documentInfo
                    .otherDocuments !== undefined
            ) {
                arr =
                    this.$store.state.registration.form.documentInfo
                        .otherDocuments
            }
            arr.push(fileObj)
            this.updateOriginalFileName(arr)
        },
        updateOriginalFileName(newValue) {
            this.$store.commit('updateField', {
                key: 'documentInfo.otherDocuments',
                value: newValue,
            })
        },

        async onSubmit() {
            // validate the form fields
            if (this.redirection) {
                const result = await this.$validator.validateAll()

                // Check if validation fails
                if (result) {
                    // this.$store.commit('setLoading', true)
                    // console.log('public registration')
                    // console.log(this.$route.meta.publicRegistration)

                    this.soundon()
                    this.nextModule('on-submit')
                } else {
                    this.$store.commit('setError', this.errors.all()[0])
                }
            } else {
                this.$store.commit(
                    'setError',
                    'Your uploaded document has not been verified by our system, please try again.'
                )
            }
        }, // End of onSubmit() method
        soundon() {
            const sound =
                'data:audio/mpeg;base64,SUQzBAAAAAABEVRYWFgAAAAtAAADY29tbWVudABCaWdTb3VuZEJhbmsuY29tIC8gTGFTb25vdGhlcXVlLm9yZwBURU5DAAAAHQAAA1N3aXRjaCBQbHVzIMKpIE5DSCBTb2Z0d2FyZQBUSVQyAAAABgAAAzIyMzUAVFNTRQAAAA8AAANMYXZmNTcuODMuMTAwAAAAAAAAAAAAAAD/80DEAAAAA0gAAAAATEFNRTMuMTAwVVVVVVVVVVVVVUxBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQsRbAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQMSkAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV'
            this.soundeffect.src = sound
            this.$store.commit('updateField', {
                key: 'soundSrc',
                value: this.soundeffect,
            })
        },

        async getBrandingData() {
            let { data } = await viewBrandingApi.list()
            this.$store.commit('setDisplaySetting', data.data)
            if(data.data.bgImages)
            {   this.brandingApiData = data.data.bgImages
                // console.log("this.customerTyp",this.customerType)
                // if(this.customerType != 'company'){
                //    this.cardImageUrl =  'logo/'+data.data.bgImages.idCard.fileName
                // }else{
                //     this.cardImageUrl =  'logo/'+data.data.bgImages.companyLicense.fileName

                // }
            }
        },

        async getRecords(association) {
            try {
                // fetch the list of associated configurations
                let { data } = await request({
                    url: `/configurations/${association}`,
                    params: {
                        dataSegmentId: this.dataSegmentId,
                        status: 'active',
                        perPage: 1000,
                        ref: 'dropdown',
                    },
                })

                // update the local list of options
                this.associateData = data.data
                //  console.log('this.associateData', this.associateData)
            } catch (error) {
                console.log(error)
            }
        }, // End of getRecords() method
        async getModuleData() {
            try {
                if (this.dataSegmentId) {
                    let { data } = await modulesApi.list({
                        dataSegmentId: this.dataSegmentId,
                    })
                    if (!_.isEmpty(data.data)) {
                        this.formData2 = data.data
                    }
                    this.showPageLoader = false
                }
            } catch (error) {
                this.showPageLoader = false
            }
        },
        setMultipleUploadDocuments(profileType) {
            //   console.log('Setting Data for UAE for profile type : ', profileType)

            if (profileType == 'Citizen') {
                this.fieldVisaPage.show = false
                // this.fieldVisaPage.isRequired = false
            } else if (profileType == 'Non-resident (tourist)') {
                this.fieldVisaPage.show = false
                // this.fieldVisaPage.isRequired = false
                this.fieldEmiratesID.show = false
                this.fieldEmiratesIDBack.show = false
                // this.fieldEmiratesID.isRequired = false
            } else {
            }
        },

        async nextModule(type = '') {
            if (this.$route.meta.publicRegistration === true) {
                this.$router.push({
                    name: 'edit-profile-setup-profile',
                    params: {
                        dataSegmentId: this.dataSegmentId,
                        token: this.$route.params.token,
                        id: this.$route.params.id,
                    },
                })
            } else {
                if (this.formData2.nameScreening == false) {
                    if (
                        // this.formData2.companyType == 'non-financial' ||
                        this.formData2.riskFactor == false
                    ) {
                        if(this.formData2.additionalInfo == false ){
                            this.$router.push({ name: 'edit-profile-preview' })
                        }else{
                            this.$router.push({ name: 'edit-profile-additional-info' })
                        }
                       
                    } else {
                        this.$router.push({ name: 'edit-profile-account-info' })
                    }
                } else {
                    if (type == 'on-submit') {
                        this.$router.push({
                            name: 'edit-profile-setup-profile',
                            params: {
                                dataSegmentId: this.dataSegmentId,
                                token: this.$route.params.token,
                                id: this.$route.params.id,
                            },
                        })
                    } else {
                        this.$router.push({
                            name: 'edit-profile-setup-profile',
                            params: { id: this.$route.params.id },
                        })
                    }
                }
            }
        },
    }, // End of Component > mounted
} // End of export default
</script>
